import React, { useState, useEffect } from 'react'
import Pagination from 'rc-pagination'
import ReportTable from './components/reportTable'
import { getOrderMonthReport } from '../../../api/cn'
import styles from './styles.scss'

const OrderForm = ({ cns, months }) => {

  const columns = [
    { title: '用户名', dataIndex: 'username', key: 'username' },
    { title: '手机号', dataIndex: 'phone', key: 'phone' },
    { title: '成交时间', dataIndex: 'payTime', key: 'payTime' },
    // { title: '订单关联渠道号', dataIndex: 'code', key: 'code' },
    // { title: '对应渠道商名称', dataIndex: 'codeName', key: 'codeName' }
  ]

  const [month, setMonth] = useState(months[0])
  const [cn, setCN] = useState(cns[0])
  const [userInfo, setUserInfo] = useState('')
  const [reportData, setReportData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [totalElement, setTotalElement] = useState(0)

  useEffect(() => {
    handleSearch()
  }, [month, cn, currentPage])

  const handleMonthChange = e => {
    const item = e.target.options[e.target.options.selectedIndex]
    setMonth({ label: item.label, value: item.value })
    setCurrentPage(1)
  }

  const handleCNChange = e => {
    const item = e.target.options[e.target.options.selectedIndex]
    setCN({ label: item.label, value: item.value })
    setCurrentPage(1)
  }

  const handleUserInfoChange = e => {
    setUserInfo(e.target.value)
  }

  const handleSearch = () => {
    const params = {
      month: month.value,
      // month: '2021-10-01',
      cn: cn.value,
      page_size: pageSize,
      page: currentPage
    }

    if (!!userInfo) {
      params.phone = userInfo
    }

    getOrderMonthReport(params, { quiet: true }).then(res => {
      if (!!res && !!res.orders) {
        const data = res.orders.data.map(item => ({
          username: item.user.name,
          phone: item.user.phone,
          payTime: item.pay_success_at
        }))
        setReportData(data)
        setTotalElement(res.orders.total)
      }
    })
  }

  const handlePageChange = e => {
    setCurrentPage(e)
  }

  const handleExport = () => {
    console.log(11111);
  }

  return (
    <div className={styles.forms}>
      <div className={styles.filter}>
        <select value={month.value} onChange={handleMonthChange}>
          {
            months.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>
        <select value={cn.value} onChange={handleCNChange}>
          {
            cns.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>
        <input value={userInfo} placeholder='手机号' onChange={handleUserInfoChange} />
        {/*<input value={canalInfo} placeholder='渠道号' onChange={handleCanalInfoChange} />*/}
        <button className={styles.changeBtn} onClick={() => {
          setCurrentPage(1)
          handleSearch()
        }}>搜索</button>
      </div>
      <div className={styles.total}>
        <div className={styles.summary}>
          <span>结算订单总数：{totalElement}</span>
        </div>
        {/*<button className={styles.changeBtn} onClick={handleExport}>导出</button>*/}
      </div>
      <ReportTable columns={columns} dataSource={reportData} />
      <div className={styles.pager}>
        <Pagination
          current={currentPage}
          defaultPageSize={pageSize}
          total={totalElement}
          onChange={handlePageChange}
        ></Pagination>
      </div>
    </div>
  )
}

export default OrderForm
